module.exports = "32256f28356fcfc15f6ddc881591cf75.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/temple-roof-mid.png
// module id = 50
// module chunks = 0